/*
 * deepLinking Sagas
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 27-Feb-2025
 */

import { put, take, call, all } from 'redux-saga/effects'
import * as deepLinkingActions from 'Store/actions/deepLinking'
import * as globalActions from 'Store/actions/global'
import * as api from 'Api/global/global'
import deepLinkService from 'Utility/deepLinkService'
import { push } from 'redux-first-history'
import { FirebaseMessaging } from 'merchant-product-push-plugin'
import { Capacitor } from '@capacitor/core'
import { openUrl } from 'Utility/globalMethods'
import { resolveLoyaltyDestination } from 'Route/NexiClub/modules/NexiClubDeepLinking'

const routeResolvers = {
  loyalty: resolveLoyaltyDestination
}

export function * executeDeepLinkDestination (destination, openInCurrentTab = false) {
  if (destination?.type === 'external' && destination.url) {
    if (openInCurrentTab && !Capacitor.isNativePlatform()) {
      yield call(openUrl, destination.url, false)
    } else {
      yield call(openUrl, destination.url, true)
    }
  } else if (destination?.type === 'internal' && destination.path) {
    yield put(push(destination.path))
  }
}

function * handleRouteAction (payload, otherParams) {
  const deepLinkingContainer = { internalPath: payload }
  const { routes } = deepLinkService
  const internalPath = deepLinkingContainer.internalPath?.toLowerCase()

  if (routes && Object.keys(routes).length > 0 && internalPath && internalPath in routes) {
    const route = routes[internalPath]
    deepLinkingContainer.depth = route.depth
    deepLinkingContainer.action = route.action
    const resolver = routeResolvers[route.resolver]

    if (typeof resolver === 'function') {
      if (Capacitor.isNativePlatform()) yield call(() => FirebaseMessaging.clearOdFromPreferences())
      const destination = yield call(resolver, otherParams)
      yield call(executeDeepLinkDestination, destination, route.resolver === 'loyalty')
    } else if (typeof deepLinkingContainer.action === 'function') {
      // if (deepLinkingContainer.depth > 1) { } // TODO manage multi depht and add global loading
      if (Capacitor.isNativePlatform()) yield call(() => FirebaseMessaging.clearOdFromPreferences())
      yield call(deepLinkingContainer.action, otherParams)
    }
    // window.dataLayer = window.dataLayer || []; // initialize dataLayer
    // window.dataLayer.push({
    //   // data for analytics
    // });
  }
}

function * handleDeepLinkingSaga (payload, otherParams) {
  const exceptions = ['HOMEPAGE', 'FAQ', 'OFFERS_SERVICES', 'SMARTPOS_API', 'MOS_LOGIN', 'DELETE_ACCOUNT']
  if (exceptions.includes(payload)) {
    yield call(handleRouteAction, payload, otherParams)
  } else {
    yield put(globalActions.checkDeepLinking.request({ payload }, { loading: true }))
    const { error, response } = yield call(api.checkDeepLinking, { payload })

    if (!error) {
      yield put(globalActions.checkDeepLinking.success(response.data))
      if (response.data.activable) {
        yield call(handleRouteAction, payload, otherParams)
      }
    } else {
      yield put(globalActions.checkDeepLinking.failure(error, { hideErrorPopup: true, ...response }))
    }
  }
}
// @generator saga

// @generator saga:watch

function * watchHandleDeepLinking () {
  while (true) {
    const { payload, otherParams } = yield take(deepLinkingActions.actionTypes.DO_HANDLE_DEEP_LINKING)
    yield call(handleDeepLinkingSaga, payload, otherParams)
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function * rootSaga () {
  yield all([
    watchHandleDeepLinking()
    // @generator saga:fork
  ])
}
